import React from "react";

import { SearchParameters } from "../../interfaces/SearchParameters.interface";

import BruksklasseSelect, {
  BruksklasseFilter,
} from "../Selection/BruksklasseSelect";

import AreaSelect from "./AreaSelect";
import SubmitButton from "../Selection/SubmitButton";

import { SharedDatePicker } from "@nvdb-rapport/shared/src/components/DatePicker";
import { UIModel, UIAction, AppState } from "../../store/ui";
import { PubliseringModel, PubliseringAction } from "../../store/publisering";
import { ArbeidModel, ArbeidAction } from "../../store/arbeid";
import * as R from "remeda";

interface Props {
  publiseringState: PubliseringModel;
  publiseringDispatch: React.Dispatch<PubliseringAction>;
  uiState: UIModel;
  uiDispatch: React.Dispatch<UIAction>;
  arbeidState: ArbeidModel;
  arbeidDispatch: React.Dispatch<ArbeidAction>;
  onSearchClick: (params: SearchParameters) => void;
}

function PubliserVeglister({
  onSearchClick,
  uiState,
  uiDispatch,
  publiseringDispatch,
  publiseringState,
  arbeidDispatch,
  arbeidState,
}: Props) {
  const areaMappings = uiState.areaMappings;
  const currentDate = publiseringState.date;
  const language = uiState.language;

  // FORM DATA

  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    publiseringDispatch({ type: "Touch", payload: "selectedFylke" });
    publiseringDispatch({ type: "Touch", payload: "selectedBruksklasse" });
    if (areaMappings !== undefined) {
      const fylkeParams: number[] =
        publiseringState.vegsystem === "FV,KV"
          ? [Number(publiseringState.selectedFylke.value.extract())]
          : Array.from(areaMappings.fylkeNrTilFylkeNavn.keys());

      const params: SearchParameters = {
        areaType: "fylker",
        bruksklasse: Number(publiseringState.selectedBruksklasse.value?.id),
        fylkesNummer: fylkeParams,
        kommuneNummer: [],
        date: publiseringState.date.value.unsafeCoerce(),
        vegsystemReferanse: publiseringState.vegsystem,
        spraak: language,
        publisering: true,
        V4: publiseringState.selectedReadversion?.value ?? true,
      };
      SearchParameters.decode(params)
        .ifLeft(e => {
          console.error(e);
          uiDispatch({
            type: "AddError",
            payload: { title: "Feil ved innsending av data", message: e },
          });
        })
        .ifRight(() => {
          uiDispatch({ type: "RequestData" });
          onSearchClick(params);
        });
    }
  };

  const isValidated = () => {
    return R.allPass(publiseringState, [
      s => s.selectedBruksklasse.value !== undefined,
      s => (s.vegsystem === "FV,KV" ? s.selectedFylke.value.isJust() : true),
    ]);
  };

  return (
    <form method="post" onSubmit={e => onFormSubmit(e)}>
      <BruksklasseSelect
        filter={BruksklasseFilter.ONLY_UNOFFICIAL}
        selectedBruksklasse={publiseringState.selectedBruksklasse}
        uiState={uiState}
        arbeidDispatch={arbeidDispatch}
        arbeidState={arbeidState}
        setSelectedBruksklasse={bruksklasse =>
          publiseringDispatch({
            type: "SelectBruksklasse",
            payload: bruksklasse,
          })
        }
      />
      <AreaSelect
        publiseringState={publiseringState}
        publiseringDispatch={publiseringDispatch}
        uiState={uiState}
      />
      <SharedDatePicker
        language={language}
        selectDate={date =>
          publiseringDispatch({ type: "SelectDate", payload: date })
        }
        currentDate={currentDate.value}
      />
      {uiState.appState !== AppState.DATA_PENDING && (
        <SubmitButton disabled={!isValidated()} />
      )}
    </form>
  );
}

export default PubliserVeglister;
